// src/i18n/es/lockerControllers.js
const lockerControllers = {
    name: 'Controlador |||| Controladores',
    titles: {
        list: 'Controladores de Taquillas',
        create: 'Crear Nuevo Controlador',
        edit: 'Editar Controlador',
        show: 'Detalles del Controlador',
        details: 'Ver detalles'
    },
    fields: {
        name: 'Nombre',
        ipAddress: 'Dirección IP',
        tcpPort: 'Puerto TCP',
        macAddress: 'Dirección MAC',
        zone: 'Zona',
        hotel: 'Hotel',
        active: 'Activo',
        isActive: 'Activo',
        connection: 'Conexión',
        connectionStatus: 'Estado de Conexión',
        status: 'Estado',
        network: 'Red',
        lockers: 'Taquillas',
        lastSeen: 'Última Conexión',
        createdAt: 'Creado el',
        updatedAt: 'Última actualización',
        firmware: 'Firmware',
        hardwareVersion: 'Hardware',
        lockerCount: 'Número de taquillas',
        activeLockerCount: 'Taquillas activas'
    },
    labels: {
        controller_name: 'Nombre del Controlador',
        controller_info: 'Información del Controlador',
        network_config: 'Configuración de Red',
        general_info: 'Información General',
        location: 'Ubicación',
        network_info: 'Información de Red',
        connection_stats: 'Estadísticas de Conexión',
        active_lockers: 'activas',
        optional: '(Opcional)',
        more_actions: 'Más acciones',
        last_connection: 'Última conexión',
        connection_time: 'Tiempo sin conexión',
        created: 'Creado',
        updated: 'Actualizado',
        hardware_version: 'Hardware',
        mac_address: 'MAC'
    },
    status: {
        online: 'En línea',
        offline: 'Desconectado',
        connected: 'Conectado',
        disconnected: 'Desconectado',
        never_connected: 'Nunca conectado',
        active: 'Activo',
        inactive: 'Inactivo',
        yes: 'Sí',
        no: 'No',
        never: 'Nunca'
    },
    search: {
        placeholder: 'Buscar...',
        zone_placeholder: 'Buscar por zona...'
    },
    filters: {
        search: 'Buscar',
        zone: 'Zona',
        status: 'Estado',
        active: 'Activo',
        inactive: 'Inactivo'
    },
    actions: {
        create: 'Crear Controlador',
        edit: 'Editar',
        delete: 'Eliminar',
        archive: 'Archivar',
        view: 'Ver detalles',
        show: 'Ver detalles',
        test_connection: 'Probar conexión',
        configure: 'Configurar'
    },
    dialogs: {
        delete: {
            title: 'Eliminar Controlador - %{name}',
            content: '¿Está seguro de que desea eliminar este controlador?',
            confirm: 'Eliminar',
            cancel: 'Cancelar'
        },
        delete_title: 'Eliminar Controlador',
        delete_message: '¿Está seguro de que desea eliminar el controlador "%{name}"?',
        delete_warning_with_lockers: 'El controlador "%{name}" tiene %{count} taquilla asignada. |||| El controlador "%{name}" tiene %{count} taquillas asignadas.',
        delete_cascade_warning: 'Esta acción afectará a las taquillas asociadas.',
        test_connection: {
            title: 'Test Connection - %{name}',
            content: 'This will attempt to establish a TCP connection with the controller to verify its status.',
            confirm: 'Test Connection',
            cancel: 'Cancel',
            testing: 'Testing...'
        }
    },
    messages: {
        no_hotel_selected: 'No hay hotel seleccionado',
        select_hotel_to_view: 'Seleccione un hotel para ver los controladores',
        no_permission_create: 'Solo los SuperAdmins pueden crear nuevos controladores de taquillas.',
        no_permission_edit: 'No tiene permisos para editar controladores',
        no_permission_access: 'No tiene permisos para acceder a esta página',
        no_permission_configure: 'Sin permisos para modificar',
        creation_success: 'Controlador creado con éxito',
        update_success: 'Controlador actualizado con éxito',
        update_error: 'Error al actualizar controlador',
        delete_success: 'Controlador eliminado con éxito',
        delete_confirm: '¿Está seguro de que desea eliminar este controlador?',
        deleted_successfully: 'Controlador eliminado con éxito',
        delete_error: 'Error al eliminar controlador',
        archive_confirm: '¿Está seguro de que desea archivar este controlador?',
        archived_successfully: 'Controlador archivado con éxito',
        archive_error: 'Error al archivar controlador',
        test_connection_success: 'Conexión establecida con éxito',
        test_connection_failed: 'Error al conectar con el controlador',
        controller_online: 'Controlador en línea',
        controller_offline: 'Controlador desconectado',
        loading: 'Cargando...',
        info_controller_management: 'Un controlador gestiona múltiples taquillas físicas a través de una conexión TCP/IP.',
        info_network_config: 'Asegúrese de que el controlador sea accesible por red antes de crearlo. Puede probar la conexión después de la creación.',
        info_controller_offline_long: 'El controlador no ha reportado conexión por más de una hora. Verifique la conectividad de red y el estado del dispositivo.',
        connection_warning: 'El controlador no ha reportado conexión por más de una hora. Verifique la conectividad de red y el estado del dispositivo.',
        has_associated_lockers: 'Este controlador tiene %{count} taquilla asociada. |||| Este controlador tiene %{count} taquillas asociadas.'
    },
    warnings: {
        delete_irreversible: 'Esta acción no se puede deshacer. El controlador será eliminado permanentemente.',
        controller_online_delete: '⚠️ El controlador está actualmente en línea. Se recomienda desconectarlo antes de eliminarlo.',
        delete_consequences: 'Las taquillas asociadas con este controlador pueden volverse inaccesibles después de esta acción.',
        unsaved_changes: 'Tiene cambios sin guardar. ¿Está seguro de que desea salir?',
        network_connectivity: 'Asegúrese de que el controlador sea accesible por red antes de crearlo. Puede probar la conexión después de la creación.'
    },
    errors: {
        controller_in_use: 'El controlador está en uso',
        has_lockers: 'El controlador tiene taquillas asignadas',
        creation_failed: 'Error al crear controlador',
        update_failed: 'Error al actualizar controlador',
        delete_failed: 'Error al eliminar controlador',
        load_failed: 'Error al cargar datos',
        permission_denied: 'No tiene permisos para realizar esta acción',
        connection_failed: 'Error al conectar con el controlador'
    },
    help: {
        name: 'Nombre descriptivo para el controlador (ej. Controlador Zona A)',
        ip_address: 'Dirección IP del controlador (IPv4 o IPv6)',
        tcp_port: 'Puerto TCP para comunicación',
        mac_address: 'Formato: XX:XX:XX:XX:XX:XX',
        zone: 'Zona donde está físicamente ubicado el controlador',
        zone_optional: 'Zona (Opcional)',
        active: 'Deshabilitar si el controlador está fuera de servicio'
    },
    validation: {
        name_required: 'El nombre del controlador es obligatorio',
        name_min_length: 'El nombre debe tener al menos 2 caracteres',
        name_max_length: 'El nombre no puede tener más de 100 caracteres',
        ip_required: 'La dirección IP es obligatoria',
        ip_invalid: 'Formato de dirección IP inválido',
        port_required: 'El puerto TCP es obligatorio',
        port_range: 'El puerto debe estar entre 1 y 65535',
        hotel_required: 'El hotel es obligatorio',
        zone_required: 'La zona es obligatoria',
        mac_invalid: 'Formato de dirección MAC inválido'
    },
    tooltips: {
        last_connection: 'Última conexión: %{date}',
        test_connection: 'Probar conexión',
        controller_actions: 'Acciones para controlador %{name}',
        minutes_ago: 'hace %{minutes} minutos',
        hours_ago: 'hace %{hours} horas',
        days_ago: 'hace %{days} días',
        online_status: 'Estado: En línea',
        offline_status: 'Estado: Desconectado'
    },
    time: {
        minutes: 'minutos',
        hours: 'horas',
        days: 'días',
        ago: 'hace'
    },
    ui: {
        network_configuration: 'Configuración de Red',
        connected: 'Conectado',
        disconnected: 'Desconectado',
        ip_address: 'Dirección IP',
        tcp_port: 'Puerto TCP',
        mac_address: 'Dirección MAC',
        connection_status: 'Estado de Conexión',
        connection_stats: 'Estadísticas de Conexión',
        last_connection: 'Última conexión:',
        connection_time: 'Tiempo sin conexión:',
        never: 'Nunca',
        online_status: 'Estado: En línea',
        minutes_ago: 'Hace %{minutes} minutos',
        offline_warning: 'El controlador lleva más de una hora sin reportar conexión. Verifique la conectividad de red y el estado del dispositivo.',
        edit_title: 'Modificar Controlador de Taquilla'
    },
    notifications: {
        load_controller_error: 'Error al cargar el controlador',
        connection_success: 'Conexión exitosa',
        connection_failed: 'No se pudo conectar con el controlador',
        test_connection_error: 'Error al probar la conexión',
        controller_deleted_success: 'Controlador eliminado con éxito',
        controller_delete_error: 'Error al eliminar el controlador',
    }
};

export default lockerControllers;
